import Swiper from 'swiper';
import { Navigation, HashNavigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import CIHotspot from '@cloudimage/hotspot';
// import {scrollToggleFixed} from "../../utils/scrollFixedNav";
// require("../../bootstrap");

require('../../../sitio');
import InitTabs from '@utils/initTabs';
const PopupManager = require('@/utils/PopupManager');

document.addEventListener('DOMContentLoaded', function ()
{

    Fancybox.bind("[data-fancybox]", {
        Toolbar: {
            display: {
                left: ["infobar"],
                middle: [],
                right: ["close"],
            },
        },
    });

    const swiperBannerTownhouseEl = document.querySelector(".swiper-bn-townhouse");
    if (swiperBannerTownhouseEl) {
        const swiperBannerTownhouse = new Swiper(swiperBannerTownhouseEl, {
            loop: true,
            modules: [Navigation],
            navigation: {
                nextEl: ".swiper-next-bn-townhouse",
                prevEl: ".swiper-prev-bn-townhouse",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 10
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 10
                },
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 10
                }
            }
        });
    }

    const swiperAttributesEl = document.querySelector(".swiper-attributes");
    if (swiperAttributesEl) {
        const swiperAttributesTownhouse = new Swiper(swiperAttributesEl, {
            loop: true,
            modules: [Navigation],
            navigation: {
                nextEl: ".swiper-next-attributes",
                prevEl: ".swiper-prev-attributes",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                }
            }
        });
    }

    document.querySelectorAll('.swiper-model-gallery').forEach((el) => {
        const id = el.dataset.galleryId;

        new Swiper(el, {
            loop: true,
            modules: [Navigation],
            navigation: {
                nextEl: `.swiper-next-gallery--${id}`,
                prevEl: `.swiper-prev-gallery--${id}`,
            },
            breakpoints: {
                320: {
                    slidesPerView: 2,
                    spaceBetween: 10
                },
                390: {
                    slidesPerView: 3,
                    spaceBetween: 10
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 10
                },
            },
        });
    });

    const swiperModelsEl = document.querySelector(".swiper-models");
    if (swiperModelsEl) {
        const swiperModels = new Swiper(swiperModelsEl, {
            loop: false,
            modules: [Navigation],
            navigation: {
                nextEl: ".swiper-next-models",
                prevEl: ".swiper-prev-models",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                }
            },
        });
    }

    const promo = document.querySelector('#promotion-quotes');

    if (promo) {
        const inner = promo.querySelector('.promotion');
        const btnClose = promo.querySelector('.btn-close');

        let cycleInterval;
        let hideTimeout;

        // Función para mostrar con fadeIn
        function fadeIn(element) {
            promo.style.display = 'block';
            // Pequeño delay para que la transición funcione
            setTimeout(() => {
                element.classList.remove('fade-out');
                element.classList.add('fade-in');
            }, 10);
        }

        function fadeOut(element) {
            element.classList.remove('fade-in');
            element.classList.add('fade-out');

            element.addEventListener('transitionend', function handler() {
                promo.style.display = 'none';
                element.removeEventListener('transitionend', handler);
            }, { once: true });
        }

        function startCycle() {
            fadeIn(inner);

            hideTimeout = setTimeout(() => {
                fadeOut(inner);
            }, 10000);
        }

        startCycle();

        // Repetir cada 30 segundos (10s visible + 20s oculto)
        cycleInterval = setInterval(startCycle, 30000);

        if (btnClose) {
            btnClose.addEventListener('click', () => {
                clearTimeout(hideTimeout);
                clearInterval(cycleInterval);
                fadeOut(inner);
            });
        }
    }

    const popupManager = new PopupManager();
    window.popupManager = popupManager;

    const section = document.querySelector('#attributes-tabs-slide');
    if (section) {
        const swiperEl = section.querySelector('[data-js="attributes-swiper"]');
        const tabsList = section.querySelector('[data-js="attributes-tabs-slide"]');

        if (swiperEl && tabsList) {
            const tabs = Array.from(tabsList.querySelectorAll('[data-js="attributes-tab"]'));
            const activeClass = 'attributes-tabs-slide__item--active';
            const AUTOPLAY_DELAY = 5000; // ms entre cambios automáticos, igual que el comportamiento original

            const setActiveTabByIndex = (index) => {
                tabs.forEach((tab) => {
                    const tabIndex = tab.dataset.slideIndex !== undefined
                        ? Number(tab.dataset.slideIndex)
                        : null;
                    const isActive = tabIndex === index;
                    tab.classList.toggle(activeClass, isActive);
                    tab.setAttribute('aria-pressed', String(isActive));
                });
            };

            // Ajusta las opciones (loop, effect, etc.) según el resto de tus swipers del sitio.
            const swiper = new Swiper(swiperEl, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                effect: 'slide',
                modules: [Autoplay, Navigation],
                autoplay: {
                    delay: AUTOPLAY_DELAY,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                navigation: {
                    nextEl: '.swiper-next-attributes-slide',
                    prevEl: '.swiper-prev-attributes-slide',
                },
                on: {
                    slideChange(instance) {
                        setActiveTabByIndex(instance.realIndex ?? instance.activeIndex);
                    },
                },
            });

            // Click en un tab -> mueve el slide y pausa el autoplay (igual que el comportamiento original)
            tabs.forEach((tab) => {
                tab.setAttribute('aria-pressed', 'false');
                if (tab.hasAttribute('disabled')) return;

                tab.addEventListener('click', () => {
                    const index = Number(tab.dataset.slideIndex);
                    if (Number.isNaN(index)) return;
                    swiper.autoplay.stop();
                    swiper.slideTo(index);
                });
            });

            // pauseOnMouseEnter no cubre el foco por teclado; lo replicamos manualmente
            tabsList.addEventListener('focusin', () => swiper.autoplay.stop());
            tabsList.addEventListener('focusout', () => swiper.autoplay.start());

            // Estado inicial: primer tab habilitado activo
            setActiveTabByIndex(swiper.realIndex ?? swiper.activeIndex);
        }
    }

    document.querySelectorAll('.townhouse-showcase__model-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const target = btn.dataset.modelTarget;

            document.querySelectorAll('.townhouse-showcase__model-btn')
                .forEach(b => b.classList.remove('townhouse-showcase__model-btn--active'));
            btn.classList.add('townhouse-showcase__model-btn--active');

            document.querySelectorAll('.townhouse-showcase__image').forEach(wrapper => {
                wrapper.classList.toggle('townhouse-showcase__image--active', wrapper.dataset.model === target);
            });
        });
    });
});


/*
const loading = document.getElementById('loading');
loading.style.opacity = '0';
loading.style.transition = 'opacity 0.4s ease';

// Ocultar completamente después de la animación
setTimeout(() => {
    loading.style.display = 'none';
}, 400); // 400ms = duración del fade
*/
